import { getCoverUrl, getWixCodeAlbumData, } from '../common/wixCodeDataNormalizer';
import { months } from '../consts/generalConsts';
import { templatePageComponents } from '../consts/templates';
import { getGalleryById, getGalleryDownloadLink, getVisitorStatus, } from '../utils/elementsUtils';
import { translateWithParams } from '../utils/generalUtils';
import _ from 'lodash';
var setShareIconsLinks = function (t, elements, url) {
    var facebook = elements.facebook, pinterest = elements.pinterest, twitter = elements.twitter, tumblr = elements.tumblr, email = elements.email;
    facebook.link = "https://www.facebook.com/sharer/sharer.php?u=".concat(url);
    facebook.target = '_blank';
    twitter.link = "http://twitter.com/share?url=".concat(url);
    twitter.target = '_blank';
    pinterest.link = "http://pinterest.com/pin/create/button/?url=".concat(url);
    pinterest.target = '_blank';
    tumblr.link = "http://tumblr.com/share/link?url=".concat(url);
    tumblr.target = '_blank';
    email.onClick(function () {
        window.open("mailto:?body=".concat(t('ALBUM_SHARE_MAILTO_BODY', {
            shareUrl: url,
        }), "&subject=").concat(t('ALBUM_SHARE_MAILTO_SUBJECT')), '_blank');
    });
};
var setSelectionsVisibility = function (elements, allowSelections) {
    var loginBox = elements.loginBox, heartIcon = elements.heartIcon;
    if (allowSelections) {
        loginBox.expand();
        heartIcon.expand();
    }
    else {
        loginBox.collapse();
        heartIcon.collapse();
    }
};
var setDownloadShareVisability = function (elements, albumData) {
    var downloadBox = elements.downloadBox, downloadMobile = elements.downloadMobile, shareBox = elements.shareBox, shareMobile = elements.shareMobile;
    if (albumData.allowAlbumDownload) {
        downloadBox.show();
        downloadMobile.show();
        downloadBox.expand();
        downloadMobile.expand();
    }
    else {
        downloadBox.hide();
        downloadMobile.hide();
        downloadBox.collapse();
        downloadMobile.collapse();
    }
    if (albumData.styleParams.allowSocial) {
        shareBox.show();
        shareMobile.show();
    }
    else {
        shareBox.hide();
        shareMobile.hide();
    }
};
var setSetsPageData = function (elements, albumData) {
    setDownloadShareVisability(elements, albumData);
    var title = elements.title, backButton = elements.backButton, downloadButton = elements.downloadButton, downloadMobile = elements.downloadMobile;
    downloadButton.link = albumData.zipUrl;
    downloadMobile.link = albumData.zipUrl;
    title.label = albumData.albumName;
    if (albumData.hideLinkToCover) {
        backButton.hide();
    }
    else {
        backButton.link = '/';
    }
    return;
};
var setSetPageData = function (elements, albumData, sets, galleryId) {
    setDownloadShareVisability(elements, albumData);
    var title = elements.title, nextGalleryButton = elements.nextGalleryButton, backButton = elements.backButton, downloadButton = elements.downloadButton, downloadMobile = elements.downloadMobile;
    var _a = getGalleryById(sets, galleryId), currentGallery = _a.currentGallery, index = _a.index;
    var nextGallery = sets[index + 1];
    if (nextGallery) {
        nextGalleryButton.link = '/set/' + nextGallery.id;
        nextGalleryButton.show();
    }
    else {
        nextGalleryButton.hide();
    }
    title.label = currentGallery === null || currentGallery === void 0 ? void 0 : currentGallery.name;
    var galleryDownloadLink = getGalleryDownloadLink(albumData.motherSiteMetaSiteId, albumData.id, galleryId);
    downloadButton.link = galleryDownloadLink;
    downloadMobile.link = galleryDownloadLink;
    if (albumData.hideLinkToCover) {
        backButton.hide();
    }
    else {
        backButton.link = albumData.setPageBackLink;
    }
};
var setListsPageData = function (t, elements, albumData) {
    var title = elements.title, backButton = elements.backButton;
    title.label = t('COLLECTIONS_LIST_TITLE');
    backButton.link = albumData.listsBackLink;
    return { elements: elements, albumData: albumData };
};
var setListPageData = function (t, elements, albumData, collection, visitorStatus) {
    setDownloadShareVisability(elements, albumData);
    var title = elements.title, listSubtitle = elements.listSubtitle, backButton = elements.backButton, downloadButton = elements.downloadButton, downloadMobile = elements.downloadMobile;
    downloadButton.link = albumData.zipUrl;
    downloadMobile.link = albumData.zipUrl;
    var status = getVisitorStatus(t, visitorStatus);
    var date = new Date(collection.createdDate);
    title.label = collection.name;
    backButton.link = albumData.listBacklink;
    listSubtitle.text = translateWithParams(t, 'COLLECTION_LIST_PAGE_SUBTITLE', {
        nickname: collection.creator.nickname,
        status: status,
        month: months[date.getMonth()],
        day: date.getDate(),
        year: date.getFullYear(),
        membersCount: collection.membersCount,
    });
};
var setAccountPageData = function (elements, albumData) {
    var title = elements.title, backButton = elements.backButton;
    var albumName = albumData.albumName, navigateToSetOrSets = albumData.listsBackLink;
    backButton.link = navigateToSetOrSets;
    title.label = albumName;
};
var setCoverPageData = function (page, elements, albumData) {
    var isModern = page === "modern" /* COVER.MODERN */;
    var isMinimal = page === "minimal" /* COVER.MINIMAL */;
    var title = elements.title, logo = elements.logo, coverButton = elements.coverButton, moreInfo = elements.moreInfo, photographerName = elements.photographerName, coverImage = elements.coverImage;
    if (isMinimal) {
        coverImage.options = albumData.coverOptions;
        coverImage.items = albumData.coverItemMobile;
    }
    else {
        coverImage.src = albumData.coverUrl;
    }
    title.text = albumData.albumName;
    moreInfo.text = albumData.albumDate;
    photographerName.label = albumData.brand.name;
    coverButton.label = albumData.welcome;
    coverButton.link = albumData.coverLink;
    if (albumData.logoUrl) {
        if (isModern) {
            logo.show();
            logo.manualStyleParams = { behaviourParams_item_clickAction: 'LINK' };
            albumData.logoNativePGItem[0].link = {
                href: albumData.motherSiteUrl,
                target: '_blank',
            };
            logo.items = albumData.logoNativePGItem;
        }
        else {
            logo.show();
            logo.clickAction = 'link';
            albumData.logoItems[0].link = albumData.motherSiteUrl;
            logo.items = albumData.logoItems;
        }
    }
    else {
        logo.hide();
    }
    photographerName.link = albumData.motherSiteUrl;
};
export var getPageElements = function (page, $w) {
    var pageComps = templatePageComponents.v8[page];
    var elements = {};
    pageComps.components.forEach(function (component) {
        var element = $w("@".concat(component.role))[0];
        if (element) {
            elements["".concat(component.role)] = element;
        }
    });
    return elements;
};
export var initElementsInEditor = function (_a) {
    var _b;
    var page = _a.page, $w = _a.$w, t = _a.t, albumData = _a.albumData, collection = _a.collection, galleryId = _a.galleryId, visitorStatus = _a.visitorStatus, coverMaxSize = _a.coverMaxSize;
    var elements = getPageElements(page, $w);
    if (!elements || Object.keys(elements).length === 0) {
        return;
    }
    var albumSettings = albumData.settings ||
        albumData.albumData;
    var albumSets = ((_b = albumData.sets) === null || _b === void 0 ? void 0 : _b.gallery) || albumData.sets;
    var shareUrl = albumSettings.publicUrl;
    // const sets = getWixCodeGalleryItems(albumSets, albumSettings);
    var wixCodeAlbumData = getWixCodeAlbumData(albumSettings, albumSets, {
        coverMaxSize: coverMaxSize,
    });
    switch (page) {
        case "classic" /* COVER.CLASSIC */:
        case "minimal" /* COVER.MINIMAL */:
        case "timeless" /* COVER.TIMELESS */:
        case "modern" /* COVER.MODERN */:
        case "formal" /* COVER.FORMAL */:
        case "gradientleft" /* COVER.GRADIENTLEFT */:
        case "gradientbottom" /* COVER.GRADIENTBOTTOM */:
        case "halfhalf" /* COVER.HALFHALF */:
        case "infoleft" /* COVER.INFOLEFT */:
            setCoverPageData(page, elements, wixCodeAlbumData);
            break;
        case "profile" /* PAGE.PROFILE */:
        case "myaccount" /* PAGE.MY_ACCOUNT */:
        case "settings" /* PAGE.SETTINGS */:
        case "notifications" /* PAGE.NOTIFICATIONS */:
            setAccountPageData(elements, wixCodeAlbumData);
            break;
        case "sets" /* PAGE.SETS */:
            setSelectionsVisibility(elements, wixCodeAlbumData.allowSelections);
            setShareIconsLinks(t, elements, shareUrl);
            setSetsPageData(elements, wixCodeAlbumData);
            break;
        case "set" /* PAGE.SET */:
            setSelectionsVisibility(elements, wixCodeAlbumData.allowSelections);
            setShareIconsLinks(t, elements, shareUrl);
            galleryId &&
                setSetPageData(elements, wixCodeAlbumData, albumSets, galleryId);
            break;
        case "lists" /* PAGE.LISTS */:
            setListsPageData(t, elements, wixCodeAlbumData);
            break;
        case "list" /* PAGE.LIST */:
            setShareIconsLinks(t, elements, shareUrl);
            collection &&
                visitorStatus &&
                setListPageData(t, elements, wixCodeAlbumData, collection, visitorStatus);
            break;
        default:
            break;
    }
    var coverUrl;
    try {
        var firstItem = _.get(albumSets, '[0].items[0]');
        coverUrl = getCoverUrl(albumSettings, albumSets, firstItem);
    }
    catch (e) {
        console.error('failed to set seo');
    }
    return { convertedAlbumData: wixCodeAlbumData, sets: albumSets, coverUrl: coverUrl };
};
//# sourceMappingURL=editorElementsService.js.map